// extracted by mini-css-extract-plugin
module.exports = {"section-root":"Section_section-root__3eaKv"};